import Button from "ds/components/Button";
import Tooltip from "ds/components/Tooltip";

import BlueprintsFeatureGateTooltip from "../FeatureGate/Tooltip";
import { BlueprintActions } from "../FeatureGate/types";

type CreateStackButtonProps = {
  isPublished: boolean;
  stackCreateLoading: boolean;
};

const CreateStackButton = ({ isPublished, stackCreateLoading }: CreateStackButtonProps) => {
  if (!isPublished) {
    return (
      <Tooltip
        active
        widthMode="maxWidthSm"
        on={(props) => (
          <span {...props}>
            <Button variant="primary" disabled>
              Create stack
            </Button>
          </span>
        )}
      >
        This is just a template preview, you will not be able to create a stack from it.
      </Tooltip>
    );
  }

  return (
    <BlueprintsFeatureGateTooltip
      action={BlueprintActions.CreateStack}
      on={({ isDisabled, ...props }) => (
        <span {...props}>
          <Button
            variant="primary"
            type="submit"
            disabled={isDisabled}
            loading={stackCreateLoading}
          >
            Create stack
          </Button>
        </span>
      )}
    />
  );
};

export default CreateStackButton;
